module.exports = __webpack_public_path__ + "img/lens-167-minus-07.846c5197.png";